/**
 * Represents validation rules for custom fields
 */
export interface ValidationRules {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  pattern?: string;
  minDate?: string;
  maxDate?: string;
}

/**
 * Represents a custom field definition
 */
export interface CustomFieldDefinition {
  id?: string;
  FieldName: string; // alphanumeric + underscore, 1-64 chars, starts with letter, camelCase in storage
  DisplayLabel: string;
  FieldType: CustomFieldType;
  ValidationRules: string; // JSON string of ValidationRules
  DisplayOrder: number;
  IsReadOnly: boolean;
  IsHidden: boolean;
  VertexType: string;
  Options?: string; // JSON string or comma-separated string for select, multiselect, radio, checkbox types
}

/**
 * Supported custom field types
 */
export enum CustomFieldType {
  Text = 'Text',
  Textarea = 'Text area',
  Number = 'Number',
  Email = 'Email',
  Url = 'Url',
  Date = 'Date',
  DateTime = 'DateTime',
  Select = 'Select',
  MultiSelect = 'MultiSelect',
  Radio = 'Radio',
  Checkbox = 'Checkbox',
  Toggle = 'Toggle',
  Color = 'Color',
  Phone = 'Phone'
}

export enum VertextTypes {
  Event = 'Event',
  Promo = 'Promo',
  Offer = 'Offer',
  OfferGroup = 'OfferGroup',
  Product = 'Product',
  ProductCategory = 'ProductCategory',
  Asset = 'Asset'
}